module.exports = __webpack_public_path__ + "img/a-ziyuan14.37193f2e.png";